import { render, staticRenderFns } from "./MbPuzzle.vue?vue&type=template&id=63f564de&scoped=true&"
import script from "./MbPuzzle.vue?vue&type=script&lang=js&"
export * from "./MbPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./MbPuzzle.vue?vue&type=style&index=0&id=63f564de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f564de",
  null
  
)

export default component.exports